import { makeStyles } from '@mui/styles'
import React from 'react'
import { useRecoilValue } from 'recoil';
import { userState } from 'src/store/user/userState';
import SubHeader from './SubHeader';
import SubHeaderUserRegistered from './SubHeaderUserRegistered';
import theme from 'src/theme';

const BannerHome = () => {
    const classes = useStylesBannerHome();

    const user = useRecoilValue(userState);

    return (
        <div className={classes.root} style={{ maxHeight: !user.isAuthenticated ? '172px' : 'none' }}>
            {
                user.isAuthenticated ? <SubHeaderUserRegistered />
                    : <SubHeader />
            }
        </div>
    )
}

export const useStylesBannerHome = makeStyles({
    root: {
        //maxHeight: '172px',
        width: '100%',
        backgroundSize: "cover",
        backgroundImage: `url('${process.env.REACT_APP_ROOT_SERVER_PATH}/static/images/bg-index-0.png')`,
        backgroundPosition: "center",
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: '68px',
        paddingTop: '16px',
        paddingBottom: '16px',
    },
    noimage: {
        minHeight: '175px',
        width: '100%',
        backgroundSize: "cover",
        // backgroundImage: `url('${process.env.REACT_APP_ROOT_SERVER_PATH}/static/images/bg-index-0.png')`,
        backgroundPosition: "center",
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: '68px',
        paddingTop: '2px',
        paddingBottom: '2px',
        backgroundColor: theme.palette.primaryLight.main,
    }    
});

export default BannerHome
